
import {Component, Prop, Vue} from "vue-property-decorator";
import RelayExceptionalClosures from "@/components/relays/RelayExceptionalClosures.vue";
import {TranslateResult} from "vue-i18n";
import { Getter } from "vuex-class";

@Component({
    components: {
        RelayExceptionalClosures,
    },
})
export default class KeyRelays extends Vue {
    @Prop({default: []})
    public relays: any[];

    @Prop({default: null})
    public title: TranslateResult;

    @Prop({default: false})
    public canDeleteRelay: boolean;

    @Getter private isMobile: boolean;

    private day = new Date().getDay();
    private showSchedule: boolean = false;

    private mounted() {
        this.showSchedule = !this.isMobile;
    }

    private displaySchedule(day) {
        if (day.isActive) {
            if (day.continuous.isActive) {
                return `${day.continuous.fromHours} - ${day.continuous.toHours}`;
            } else if (day.morning.isActive && day.evening.isActive) {
                return `${day.morning.fromHours} - ${day.morning.toHours} / ${day.evening.fromHours} - ${day.evening.toHours}`;
            }
        }
    }
}
